import { TableInputChoices } from "@tellescope/types-models";
import { DatePicker, Input, Select, SelectContent, SelectItem, SelectTrigger } from "@tellescope/ui";
import { DatabaseSelectField } from "../DatabaseSelectField/DatabaseSelectField";
import { formatDate } from "@tellescope/utils";
import { parseDatabaseRecordResponse } from "../DatabaseSelectField";

export type InputTableCellProps<T extends keyof TableInputChoices> = TableInputChoices[T] & {
  id: string;
  value: string;
  onChange: (value: string) => void;
};

export const InputTableCell = <T extends keyof TableInputChoices>({ id, type, ...rest }: InputTableCellProps<T>) => {
  switch (type) {
    case "Database": {
      const { value, onChange } = rest as Omit<InputTableCellProps<"Database">, "type">;
      return (
        <DatabaseSelectField
          value={parseDatabaseRecordResponse(value)}
          id={id}
          onChange={(newVal) => onChange(JSON.stringify(newVal))}
          options={{
            databaseId: "databaseId" in rest.info ? rest.info.databaseId : undefined,
            databaseLabel: "databaseLabel" in rest.info ? rest.info.databaseLabel : undefined,
          }}
        />
      );
    }
    case "Text": {
      const { value, onChange, label } = rest as Omit<InputTableCellProps<"Text">, "type">;
      return <Input value={value} onChange={(e) => onChange(e.target.value)} placeholder={label} />;
    }
    case "Select": {
      const { value, onChange, label, info } = rest as Omit<InputTableCellProps<"Select">, "type">;
      return (
        <Select value={value} onValueChange={onChange}>
          <SelectTrigger>{value || label}</SelectTrigger>
          <SelectContent>
            {info.choices.map((choice) => (
              <SelectItem key={choice} value={choice}>
                {choice}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      );
    }
    case "Date": {
      const { value, onChange } = rest as Omit<InputTableCellProps<"Date">, "type">;
      return (
        <DatePicker
          value={value ? new Date(value) : undefined}
          onChange={(value) => onChange(value?.toISOString() ?? "")}
          placeholder={formatDate(new Date(), "MM/DD/YYYY")}
          label=""
          displayFormat="MM/DD/YYYY"
        />
      );
    }
  }
};
